if (!customElements.get('results-list')) {
  class ResultsList extends HTMLElement {
    constructor() {
      super();
      this.viewBySelection = null;
      this.resultsList = null;
    }
    // AbortController to handle cleanup
    #controller = new AbortController();

    connectedCallback() {
      this.viewBySelection = this.querySelector('#view-by-selection');
      this.resultsList = this.querySelector('#ResultsList');

      if (!this.viewBySelection || !this.resultsList) return;

      // Attach event listeners for all spans that can be selected
      this.viewBySelection
        .querySelectorAll('span[data-mobile-columns], span[data-desktop-columns]')
        .forEach(span => {
          span.addEventListener('click', (e) => this.handleSelection(e), { signal: this.#controller.signal });
      });
      this.updateColumns();
    }
    disconnectedCallback() {
      // Disconnect all the event listeners
      this.#controller.abort();
    }
    handleSelection(event) {
      if (!event.target) {
        console.warn('No element found');
        return;
      };
      const clicked = event.target;
      const parent = clicked.parentElement;

      if (!clicked || !parent) {
        console.warn('No element found');
        return;
      }

      // Remove previous 'selected' in the same group
      parent.querySelectorAll('.selected').forEach(el => el.classList.remove('selected'));
      clicked.classList.add('selected');
      
      // Update CSS variables
      this.updateColumns();
    }
    updateColumns() {
      const selectedMobile = this.viewBySelection && this.viewBySelection.querySelector('[data-mobile-columns].selected');
      const selectedDesktop = this.viewBySelection && this.viewBySelection.querySelector('[data-desktop-columns].selected');

      const mobileCols = selectedMobile ? selectedMobile.dataset.mobileColumns : 1;
      const desktopCols = selectedDesktop ? selectedDesktop.dataset.desktopColumns : 3;

      this.resultsList.style.setProperty('--mobile-columns', `repeat(${mobileCols}, minmax(0, 1fr))`);
      this.resultsList.style.setProperty('--desktop-columns', `repeat(${desktopCols}, minmax(0, 1fr))`);
    }
  }
  customElements.define('results-list', ResultsList);
}
